var e={removePadding:"cat-removePadding__kVEo-p",imageWrapper:"cat-imageWrapper__ooAVnw",image:"cat-image__RU9P8t",modelCodeLabel:"cat-modelCodeLabel__q2z8EY"};export{e as default};
